export default function MobileFallback() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Animated gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 30% 20%, rgba(30,64,175,0.2) 0%, transparent 50%), " +
            "radial-gradient(ellipse at 70% 80%, rgba(124,58,237,0.15) 0%, transparent 50%), " +
            "radial-gradient(ellipse at 50% 50%, rgba(6,182,212,0.08) 0%, transparent 60%)",
        }}
      />

      {/* Floating geometric shapes */}
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Floating diamond */}
        <g className="animate-float" style={{ animationDelay: "0s" }}>
          <polygon
            points="80,60 100,40 120,60 100,80"
            fill="none"
            stroke="rgba(124,58,237,0.2)"
            strokeWidth="1"
          />
        </g>

        {/* Floating hexagon */}
        <g
          className="animate-float"
          style={{ animationDelay: "1s", transformOrigin: "center" }}
        >
          <polygon
            points="280,120 300,108 320,120 320,144 300,156 280,144"
            fill="none"
            stroke="rgba(30,64,175,0.2)"
            strokeWidth="1"
          />
        </g>

        {/* Floating triangle */}
        <g className="animate-float" style={{ animationDelay: "2s" }}>
          <polygon
            points="60,300 80,260 100,300"
            fill="none"
            stroke="rgba(6,182,212,0.15)"
            strokeWidth="1"
          />
        </g>

        {/* Floating circle */}
        <g className="animate-float" style={{ animationDelay: "3s" }}>
          <circle
            cx="300"
            cy="350"
            r="25"
            fill="none"
            stroke="rgba(124,58,237,0.15)"
            strokeWidth="1"
          />
        </g>

        {/* Small dots */}
        {Array.from({ length: 20 }).map((_, i) => (
          <circle
            key={i}
            cx={30 + Math.random() * 300}
            cy={30 + Math.random() * 500}
            r={1 + Math.random() * 2}
            fill={`rgba(${100 + Math.random() * 100}, ${80 + Math.random() * 80}, ${200 + Math.random() * 55}, ${0.1 + Math.random() * 0.2})`}
            className="animate-pulse-slow"
            style={{ animationDelay: `${Math.random() * 4}s` }}
          />
        ))}

        {/* Connecting lines */}
        <line
          x1="100"
          y1="60"
          x2="280"
          y2="120"
          stroke="rgba(124,58,237,0.06)"
          strokeWidth="1"
        />
        <line
          x1="300"
          y1="140"
          x2="80"
          y2="280"
          stroke="rgba(30,64,175,0.06)"
          strokeWidth="1"
        />
      </svg>

      {/* Gradient overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-bg-primary to-transparent" />
    </div>
  );
}
